import { render, staticRenderFns } from "./widget-template-creator.vue?vue&type=template&id=2ec581d0&scoped=true&"
import script from "./widget-template-creator.vue?vue&type=script&lang=js&"
export * from "./widget-template-creator.vue?vue&type=script&lang=js&"
import style0 from "./widget-template-creator.vue?vue&type=style&index=0&id=2ec581d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec581d0",
  null
  
)

export default component.exports